import axios from 'axios';
import qs from 'qs';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import { getToken, getPhone, getSchoolId } from '@/utils/auth';

// create an axios instance
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  withCredentials: true,
  // send cookies when cross-domain requests
  timeout: 10000 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  // do something before request is sent
  config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  if (config.method === 'post') {
    if (!config.data) {
      config.data = {
        client_id: 501,
        source: 501
      }; //http://wiki.educlouddata.com/index.php/Home/Item/show?item_id=9
    }
    if (config.data && !config.data.client_id) {
      config.data.client_id = 501;
      config.data.source = 501;
    }
    config.data = qs.stringify(config.data);
  }
  if (store.getters.token) {
    config.headers['token'] = getToken();
    config.headers['phone'] = getPhone();
    config.headers['school_id'] = getSchoolId();
    config.headers['source'] = 'P';
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  var res = response.data;
  console.log(res);
  // if the custom code is not 20000, it is judged as an error.
  if (res.code !== 0) {
    // 403: Illegal token; 406: Other clients logged in; 409: Token expired;
    if (res.code === 406) {
      // to re-login
      MessageBox.confirm('您的登录已失效, 你可以重新登录或者取消继续留在这个页面', '登录失效', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(function () {
        store.dispatch('user/resetToken').then(function () {
          location.reload();
        });
      });
    } else if (res.code === 403) {
      Message.error(res.msg || '您无权访问请求的数据');
      return res;
    } else if (res.code === 203 || res.code === 501) {
      Message.error(res.msg || '您的访问出现错误，请联系管理人员');
    } else {
      //if (process.env.NODE_ENV == 'development') {
      if (res.code != 600) Message.error(res.msg || '您的访问出现错误，请联系管理人员');
      //}
    }
    return Promise.reject(res);
  } else {
    return res;
  }
}, function (error) {
  console.log('err' + error); // for debug
  //Message({
  //  message: error.message,
  //  type: 'error',
  //  duration: 5 * 1000
  //})
  //if (process.env.NODE_ENV == 'development') {
  Message.error(error.message || '您的访问出现错误，请联系管理人员');
  //}
  return Promise.reject(error);
});
export default service;